import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useServiceRequests } from '@/hooks/useRequests'
import routes from '@/routes/routes'
import './ActiveServiceBanner.css'

const ActiveServiceBanner = () => {
    const { data: serviceRequests } = useServiceRequests()
    const navigate = useNavigate()

    const active = useMemo(() => {
        if (!Array.isArray(serviceRequests)) return null
        const now = new Date()
        const oneHour = 60 * 60 * 1000
        return serviceRequests.find((req: any) => {
            if (req.status === 'in_progress') return true
            if (req.status === 'completed' && !req.client_confirmed_satisfaction) return true
            if (req.status === 'payment_confirmed' && req.scheduled_date) {
                // Parse date string as local date to avoid timezone shift
                let dt: Date
                if (typeof req.scheduled_date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(req.scheduled_date)) {
                    const [year, month, day] = req.scheduled_date.split('-').map(Number)
                    dt = new Date(year, month - 1, day)
                } else {
                    dt = new Date(req.scheduled_date)
                }
                if (typeof req.scheduled_hour === 'number') dt.setHours(req.scheduled_hour, 0, 0, 0)
                return dt.getTime() - now.getTime() <= oneHour && dt.getTime() > now.getTime()
            }
            return false
        })
    }, [serviceRequests])

    if (!active) return null

    const time = (() => {
        if (!active.scheduled_date) return ''
        const startHour = typeof active.scheduled_hour === 'number' ? active.scheduled_hour : 0
        const endHour = startHour + (active.estimated_duration_hours || 1)
        return `${String(startHour).padStart(2, '0')}:00 - ${String(endHour).padStart(2, '0')}:00`
    })()

    return (
        <div className="activebanner_container" onClick={() => navigate(routes.requests)}>
            <div className="activebanner_icon">⏱</div>
            <div className="activebanner_content">
                <div className="activebanner_title">Servicio activo</div>
                <div className="activebanner_sub">
                    {active.service_name || 'Servicio'} · {time}
                </div>
            </div>
            <button className="activebanner_cta">Ver</button>
        </div>
    )
}

export default ActiveServiceBanner



